import { useCallback, useEffect, useState } from "react";
import { z } from "zod";
import { apiRequest } from "../../shared/api/client";
import type { PackagingPlanRow } from "./week39-types";

const entryResponseSchema = z.object({
  frozenAt: z.iso.datetime().optional(), aggregated: z.literal(true).optional(),
  observedAt: z.iso.datetime(), truncated: z.boolean(), items: z.array(z.object({
    id: z.string().min(1), date: z.iso.date(), recordedAt: z.string().nullable(), quantity: z.number().finite(),
    unit: z.string().nullable(), documentNo: z.string().nullable(), batchCode: z.string().nullable(), lotNo: z.string().nullable(),
  })),
});
export type EntryResponse = z.infer<typeof entryResponseSchema>;

export function useWeek39Entries(plan: PackagingPlanRow, weekStart: string) {
  const [data, setData] = useState<EntryResponse | null>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async (signal?: AbortSignal) => {
    setLoading(true); setError("");
    try {
      const query = new URLSearchParams({ workOrderNo: plan.workOrderNo, productCode: plan.productCode, weekStart });
      const result = entryResponseSchema.parse(await apiRequest<unknown>(`/api/sarf39/manual-packaging/entries?${query}`, { cache: "no-store", signal }));
      if (!signal?.aborted) setData(result);
    } catch (reason) {
      if (!signal?.aborted) setError(reason instanceof Error ? reason.message : "Mikro girişleri alınamadı.");
    } finally { if (!signal?.aborted) setLoading(false); }
  }, [plan.productCode, plan.workOrderNo, weekStart]);
  useEffect(() => {
    const controller = new AbortController();
    void reload(controller.signal);
    return () => controller.abort();
  }, [reload]);
  return { data, error, loading, reload };
}
